(function () {
    'use strict';
    var m = angular.module('dashboard');
    m.factory('modulesStatsLogic', ["$q", "policyDao", "modulesDao", "path", "modulesManager", "feature", "$filter", "routeHelper", "troubleshooting", "$rootScope", "$timeout", "policiesRefreshHelper", "secAppsStatusDao", "securityEventsLinkGenerator", "securityEventTypes", function ($q, policyDao, modulesDao, path, modulesManager, feature, $filter, routeHelper, troubleshooting, $rootScope, $timeout, policiesRefreshHelper, secAppsStatusDao, securityEventsLinkGenerator, securityEventTypes) {
        var sectionsConfig = [
            {
                id: 'found',
                label: 'Found',
                'class': 'module-stats-found'
            },
            {
                id: 'confident',
                label: 'Found',
                'class': 'module-stats-found'
            },
            {
                id: 'suspicious',
                label: 'Suspected',
                'class': 'module-stats-suspected'
            }
        ];
        function makeToolTip(section, url, text) {
            if (!section.total) {
                return null;
            }
            return {
                content: { text: '<div class="infobox-tooltip"><a href="' + url + '">' + text + '</a></div>' },
                position: {
                    at: 'bottom center',
                    my: 'top center',
                    viewport: true
                },
                hide: {
                    delay: 200,
                    fixed: true
                },
                style: { classes: 'qtip-standard qtip-infobox' }
            };
        }
        function addFoundLines(lines, module, v2Mode) {
            if (module.info.learning_mode) {
                lines.push({
                    text: '#' + JSON.stringify({
                        display: 'text',
                        text: 'Learning',
                        'class': 'display-block'
                    }) + '#' + JSON.stringify({
                        display: 'text',
                        text: 'mode',
                        'class': 'display-block'
                    }),
                    'class': 'module-stats-found'
                });
                return;
            }
            _(sectionsConfig).each(function (config) {
                if (!module.sections[config.id]) {
                    return;
                }
                lines.push(formatFoundLine(module.sections[config.id], config, v2Mode));
            });
        }
        function formatFoundLine(section, config, v2Mode) {
            if (!section.total) {
                if (v2Mode) {
                    return {
                        text: '#' + JSON.stringify({
                            display: 'linked-text',
                            'class': 'display-block module-stats-check',
                            text: '#' + JSON.stringify({
                                display: 'text',
                                'class': 'fa fa-check'
                            })
                        }),
                        'class': config['class']
                    };
                } else {
                    return {
                        text: config.label + ': ' + '#' + JSON.stringify({
                            display: 'linked-text',
                            'class': 'display-block module-stats-check',
                            text: '#' + JSON.stringify({
                                display: 'linked-text',
                                'class': 'fa-stack fa-lg',
                                text: '#' + JSON.stringify({
                                    display: 'text',
                                    'class': 'fa fa-circle fa-stack-2x'
                                }) + '#' + JSON.stringify({
                                    display: 'text',
                                    'class': 'fa fa-check fa-stack-1x'
                                })
                            })
                        }),
                        'class': config['class']
                    };
                }
            }
            // remove suspicious, marketing, phishing --- from the default types filtered
            var defaultTypes = securityEventTypes.data();
            var filterTypes = [];
            defaultTypes.forEach(function (type) {
                if (![
                        'spam',
                        'marketing',
                        'suspicious'
                    ].includes(type.id)) {
                    filterTypes.push(type.id);
                }
            });
            var url = securityEventsLinkGenerator.createHref({
                matched_security_tool: section.sec_tool,
                saas: modulesManager.currentModule(),
                current_state: [
                    'new',
                    'remediated'
                ],
                type: filterTypes
            });
            return {
                text: (v2Mode ? '' : config.label + ': ') + '#' + JSON.stringify({
                    display: 'link',
                    path: url,
                    tooltip: makeToolTip(section, url, 'Click here to see events'),
                    text: '' + section.total,
                    'class': 'display-block module-stats-number'
                }),
                'class': config['class']
            };
        }
        return function ($scope, logic) {
            logic.updateTick = null;
            function isSameWidgets(oldWidgets, newWidgets) {
                if (oldWidgets.length != newWidgets.length) {
                    return false;
                }
                var found = _(oldWidgets).find(function (widget, idx) {
                    return widget.moduleName != newWidgets[idx].moduleName;
                });
                return !found;
            }
            function mergeWidgets(oldWidgets, newWidgets) {
                _(oldWidgets).each(function (widget, idx) {
                    _(newWidgets[idx].lines).each(function (line, lineIdx) {
                        _(widget.lines[lineIdx]).clearObject(line);
                    });
                });
            }
            var currentModule = modulesManager.currentModule();
            var excludeSecurityAppsForSaasApp = {
                'slack': [
                    'ap_avanan',
                    'clicktime_protection',
                    'microsoft_encryption'
                ],
                'sharefile': [
                    'ap_avanan',
                    'clicktime_protection',
                    'microsoft_encryption'
                ]
            };
            $q.all([
                secAppsStatusDao.countsBySaas([{ name: currentModule }]),
                modulesDao.getModules(),
                modulesDao.getSecEntityNames()
            ]).then(function (responses) {
                var saasCountsBySaasList = responses[0].data;
                var modulesData = responses[1].data;
                var secEntityNames = responses[2].data;
                //exclude security apps
                var saasApp = currentModule;
                var excludedSecApps = excludeSecurityAppsForSaasApp[saasApp] || [];
                excludedSecApps.forEach(function (securityApp) {
                    delete saasCountsBySaasList[securityApp];
                });
                var newWidgets = _(saasCountsBySaasList).chain().pick(function (value, moduleName) {
                    return modulesManager.isActive(moduleName);
                }).map(function (value, key) {
                    var sections = {};
                    var secTool = key;
                    if (secEntityNames && secEntityNames[key]) {
                        secTool = secEntityNames[key];
                    }
                    sections.found = {
                        total: value[currentModule],
                        sec_tool: secTool,
                        module: currentModule
                    };
                    return {
                        name: key,
                        sections: sections,
                        info: _(modulesData.apps_items.modules).find(function (module) {
                            return module.name == key;
                        })
                    };
                }).filter(function (module) {
                    return !module.info.gui_hidden || troubleshooting.entityDebugEnabled();
                }).sortBy(function (module) {
                    return parseInt(module.info.security_stack_order);
                }).sortBy(function (module) {
                    var category = _(modulesData.apps_categories.categories).find(function (cat) {
                        return cat.categoryId === module.info.category_id;
                    });
                    if (category) {
                        return parseInt(category.securityStackOrder);
                    }
                }).map(function (module, idx) {
                    var lines;
                    if (logic.mode === 'v2') {
                        lines = [
                            {
                                text: '#' + JSON.stringify({
                                    display: 'img-div',
                                    path: path('gui-v2').imgRel('icons-round/' + (module.info.stack_icon_round || (feature.checkpointTheme ? 'checkpoint.png' : 'avanan.png'))),
                                    'class': { 'module-stats-image': true }
                                })
                            },
                            {
                                text: '#' + JSON.stringify({
                                    display: 'text',
                                    text: module.info.label
                                }),
                                'class': 'module-stats-name'
                            }
                        ];
                    } else {
                        lines = [
                            {
                                text: '#' + JSON.stringify({
                                    display: 'img-div',
                                    path: path('security-stack').img('solutions/' + module.info.stack_icon),
                                    'class': { 'module-stats-image': true }
                                })
                            },
                            {
                                text: '#' + JSON.stringify({
                                    display: 'text',
                                    text: module.info.label
                                }),
                                'class': 'module-stats-category blue-text'
                            }
                        ];
                    }
                    addFoundLines(lines, module, logic.mode === 'v2');
                    var labels = [];
                    if (module.info.is_beta) {
                        labels.push('#' + JSON.stringify({
                            display: 'text',
                            text: 'BETA',
                            'class': 'beta-label'
                        }));
                    }
                    if (module.info.isExpired && !feature.checkpointTheme) {
                        labels.push('#' + JSON.stringify({
                            display: 'text',
                            text: 'EXPIRED',
                            'class': 'expired-label'
                        }));
                    }
                    if (labels.length) {
                        lines.push({
                            text: labels.join(''),
                            class: 'module-stats-labels'
                        });
                    }
                    if (idx && logic.mode !== 'v2') {
                        lines.push({
                            text: '',
                            class: 'module-stats-separator'
                        });
                    }
                    return {
                        type: 'info',
                        moduleName: module.name,
                        style: {
                            'height': logic.mode === 'v2' ? '165px' : '230px',
                            'padding': '5px'
                        },
                        lines: lines
                    };
                }).value();
                if (!$scope.model.widgets || !isSameWidgets($scope.model.widgets, newWidgets)) {
                    $scope.model.widgets = newWidgets;
                    $timeout(function () {
                        $rootScope.$broadcast('slider-size-changed');
                    });
                } else {
                    mergeWidgets($scope.model.widgets, newWidgets);
                }
            });
        };
    }]);
}());